import { render, staticRenderFns } from "./dinopop.vue?vue&type=template&id=643b2653"
import script from "./dinopop.vue?vue&type=script&lang=js"
export * from "./dinopop.vue?vue&type=script&lang=js"
import style0 from "./dinopop.vue?vue&type=style&index=0&id=643b2653&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports